"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function WanderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[0, 1, 2, 3].map(i => <li key={i} data-index={i}>
            <div className="h-5 w-32 bg-muted/40 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3 font-default">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-[15px] text-foreground/85 hover:text-primary transition-colors duration-300 hover:underline underline-offset-4 decoration-primary">
            {item.label}
          </Link><Link to={item.href || "#"} className="text-[15px] text-foreground/85 hover:text-primary transition-colors duration-300 hover:underline underline-offset-4 decoration-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const connectLinks = [{
    label: "info@mirkocolloca.it",
    to: "segreteria.drcolloca@gmail.com"
  }, {
    label: "+39 06 1234567",
    to: "+39 329 02 14 366"
  }, {
    label: "Prenota una visita",
    to: "/ContactsPage"
  }];
  const followLinks = [{
    label: "LinkedIn",
    to: "#"
  }, {
    label: "ResearchGate",
    to: "#"
  }, {
    label: "Pubmed",
    to: "Facebook"
  }, {
    label: "Twitter",
    to: "Instagram"
  }];
  const bottomLinks = [{
    label: "Privacy",
    to: "#"
  }, {
    label: "Note Legali",
    to: "#"
  }, {
    label: "Crediti",
    to: "#"
  }];
  return <section data-section-id="4982" id="footer" className="bg-background text-foreground pt-32 md:pt-40 pb-16 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-10 lg:gap-16">
          {}
          <div className="flex flex-col gap-6 lg:col-span-1">
            <Link to="/" aria-label="Home Dott. Mirko Colloca" className="inline-block">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <p className="font-default italic text-[17px] leading-relaxed text-foreground/80 max-w-xs">
              Eccellenza clinica e rigore scientifico al servizio della salute riproduttiva.
            </p>
            <address className="not-italic font-default text-[14px] leading-relaxed text-foreground/70">Viale Regina Margherita, 69<br />98122 Messina, Italia<br />P.IVA 03680890799</address>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default text-[13px] uppercase tracking-[0.2em] text-foreground/60">
              Navigazione
            </h3>
            <MenuProvider menu_id="3">
              <WanderMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default text-[13px] uppercase tracking-[0.2em] text-foreground/60">
              Contatti
            </h3>
            <ul className="flex flex-col gap-3 font-default">
              {connectLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-[15px] text-foreground/85 hover:text-primary transition-colors duration-300 hover:underline underline-offset-4 decoration-primary">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-default text-[13px] uppercase tracking-[0.2em] text-foreground/60">
              Ricerca
            </h3>
            <ul className="flex flex-col gap-3 font-default">
              {followLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} newTab className="text-[15px] text-foreground/85 hover:text-primary transition-colors duration-300 hover:underline underline-offset-4 decoration-primary">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-28">
          <Separator className="bg-foreground/30" />
        </div>

        {}
        <div className="flex justify-center my-8">
          <span aria-hidden="true" className="font-default text-2xl text-foreground/40 leading-none">
            +
          </span>
        </div>

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
          <p className="font-default italic text-[13px] text-foreground/60 text-center md:text-left">
            © MMXXIV Dott. Mirko Colloca. Tutti i diritti riservati.
          </p>
          <ul className="flex items-center gap-6 font-default">
            {bottomLinks.map((item, i) => <li key={item.label} data-index={i}>
                <Link to={item.to} className="text-[12px] uppercase tracking-[0.15em] text-foreground/60 hover:text-primary transition-colors duration-300">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}